import { Pipe, PipeTransform } from '@angular/core';
import { deepEqual } from '@markant-platform/shared/util-helpers';

@Pipe({
  name: 'objectComparator',
})
export class ObjectComparatorPipe implements PipeTransform {
  transform(array: any[], item: any): boolean {
    return array.find(el => deepEqual(el, item));
  }
}
